import React, { useEffect } from "react";
import styled from "styled-components";
import {
  UserOutlined,
  NumberOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { Form, Row, Col, Radio, Spin } from "antd";
import {
  Input,
  Select,
  DatePicker,
  RadioGroup,
  Button,
  Typography,
} from "../core";
import { MixStyle } from "../styles";
import { sendYarnAction } from "../redux/Action/Sizer/sendYarn";
import { getCompanyId } from "../helper/utils/companyId";
import { getyarnQualities } from "../helper/utils/api/settings";
import { useSizerData } from "../hooks/useSizerData";

const mapYarnQualitiesForSelect = (list = []) =>
  list.map((q) => ({
    id: q.id || q._id || q.yarn_quality_id,
    count: q.count,
    con_size: q.con_size || q.consize,
    brand: q.brand,
    type: q.type,
  }));
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const SendYarnForm = ({ sizerId }) => {
  useSizerData();
  const { token } = useSelector((state) => state.auth);
  const dispatchToAction = useDispatch();
  const [form] = Form.useForm();
  const [sendYarn, setSendYarn] = React.useState({});
  const [yarnQuality, setYarnQuality] = React.useState([]);
  const [loadingQualities, setLoadingQualities] = React.useState(false);
  const sizerList = useSelector((state) => state.sizer.sizer);

  useEffect(() => {
    const loadYarnQualities = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      setLoadingQualities(true);
      try {
        const { data } = await getyarnQualities({ companyId, limit: 200 });
        const list = data?.result || data || [];
        setYarnQuality(mapYarnQualitiesForSelect(list));
      } catch (error) {
        console.log("load yarn qualities error", error);
        setYarnQuality([]);
      }
      setLoadingQualities(false);
    };
    loadYarnQualities();
  }, []);

  const onFinish = (values) => {
    dispatchToAction(sendYarnAction(sendYarn));
    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onValuesChange = (changed, values) => {
    const {
      sizer_id,
      bags_send_yarn,
      cons_send_yarn,
      date_send_yarn,
      yarn_quality_id,
      slip_no,
      fright_paid_by,
      fright_amount,
    } = values;
    sizerId[1](sizer_id);

    setSendYarn((prev) => ({
      ...prev,
      bags_send_yarn,
      cons_send_yarn,
      company_id: getCompanyId(),
      sizer_id,
      date_send_yarn,
      yarn_quality_id,
      slip_no,
      fright_paid_by,
      fright_amount,
      token: token,
    }));
  };
  const selctdata = ["cash", "cheque"];
  return (
    <StyledForm
      autocomplete="off"
      form={form}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row
        gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
        type="flex"
        justify="center"
      >
        <Col sm={18} xs={22}>
          <label>Quantity</label>

          <Row gutter={[16, 16]}>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                name="bags_send_yarn"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Bags Quantity!",
                  },
                ]}
              >
                <Input placeholder="Bags" />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                name="cons_send_yarn"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Cons!",
                  },
                ]}
              >
                <Input placeholder="Cons (in pounds)" />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col sm={18} xs={22}>
          <Form.Item
            label="Sizer Name"
            name="sizer_id"
            rules={[
              {
                required: true,

                message: "Please select Sizer Name",
              },
            ]}
          >
            <Select
              prefixIcon={<UserOutlined />}
              placeholder="Sizer name"
              type="sizerList"
              Options={sizerList?.length ? sizerList : [<LazyLoad key="sizers" />]}
            />
          </Form.Item>
        </Col>
        <Col sm={18} xs={22}>
          <Form.Item
            label="Date"
            name="date_send_yarn"
            rules={[
              {
                required: true,
                message: "Select Date",
              },
            ]}
          >
            <DatePicker reverse="reverse" />
          </Form.Item>
        </Col>
        <Col sm={18} xs={22}>
          <Form.Item
            label="Yarn Quality"
            name="yarn_quality_id"
            rules={[
              {
                required: true,
                message: "Please select Quality",
              },
            ]}
          >
            <Select
              prefixIcon={<NumberOutlined />}
              placeholder="Quality"
              type="yarnQualities"
              selctdata={selctdata}
              Options={
                loadingQualities
                  ? [<LazyLoad key="loading" />]
                  : yarnQuality.length
                  ? yarnQuality
                  : [<LazyLoad key="empty" />]
              }
            />
          </Form.Item>
        </Col>
        {yarnQuality.length === 0 && !loadingQualities ? (
          <Col sm={18} xs={22}>
            <Typography
              as="p"
              color="#FF5687"
              text="No yarn quality found. Add yarn quality from Settings → Yarn Quality (or Overview → Add yarn quality)."
            />
          </Col>
        ) : null}
        <Col sm={18} xs={22}>
          <Form.Item
            label="Slip #"
            name="slip_no"
            rules={[
              {
                required: true,
                message: "Please Enter Slip number!",
              },
            ]}
          >
            <Input placeholder="Slip no" prefix={<DollarOutlined />} />
          </Form.Item>
        </Col>

        <Col sm={18} xs={22}>
          <Form.Item
            name="fright_paid_by"
            label="Freight paid by"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Please Select one"),
              },
            ]}
          >
            <RadioGroup placement="end-to-end">
              <Radio value="company">Company</Radio>
              <Radio value="sizer">Sizer</Radio>
              <Radio value="buyer">Buyer</Radio>
            </RadioGroup>
          </Form.Item>
        </Col>
        <Col sm={18} xs={22}>
          <Form.Item
            label="Fright Ammount"
            name="fright_amount"
            rules={[
              {
                required: true,
                message: "Please Enter Slip number!",
              },
            ]}
          >
            <Input placeholder="Freight amount" prefix={<DollarOutlined />} />
          </Form.Item>
        </Col>

        <Col sm={18} xs={22}>
          <Form.Item>
            <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
              <Typography
                text="Send"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </StyledForm>
  );
};

const LazyLoad = () => {
  return (
    <Spin style={{ display: "block", margin: "auto" }} tip="Loading..."></Spin>
  );
};
export default SendYarnForm;
